import { useState, useEffect } from 'react';
import Button from '../Button/Button';
import { Popover } from 'antd';
import { useNavigate } from 'react-router';

import { Modal } from 'antd';
import Delete from '../../assets/icons/Delete';

const LearnSubjectCard = ({
  id,
  description,
  duration,
  subject,
  type,
  schoolHeader,
  selectSchool,
  topic,
  tutor,
  published,
  lesson_count,
  viewLesson,
  course,
  el,
  publishCourse,
  deleteCourse,
  index,
}) => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const [bg, setBg] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (index % 2) {
      setBg('#FFCC1D');
    } else if (index % 3) {
      setBg('#FFAEC0');
    } else {
      setBg('#9FECDB');
    }
  }, []);

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  let desc = description
    ? description
    : 'Geometry is the a branch of mathematics that studies the sizes, shapes, positions, ... ';
  return (
    <div
      className='school-card'
      style={{
        boxShadow: `10px 10px 0px 0px ${bg}`,
        marginBottom: '32px',
      }}
    >
      <img src={schoolHeader} alt='' className='school-card__school-img' />
      <div className='school-card__body'>
        <div className='school-card__body__title'>
          <h3>
            {topic?.length > 20 ? `${topic?.substring(0, 20)}...` : topic}
          </h3>
          <p> {desc?.length > 100 ? `${desc?.substring(0, 40)}...` : desc}</p>
        </div>
        {tutor ? (
          <>
            <div className='school-card__body__flex'>
              <div className='school-card__body__flex__item'>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clipPath='url(#clip0_4214_21524)'>
                    <path
                      d='M8.00016 1.3335C4.32016 1.3335 1.3335 4.32016 1.3335 8.00016C1.3335 11.6802 4.32016 14.6668 8.00016 14.6668C11.6802 14.6668 14.6668 11.6802 14.6668 8.00016C14.6668 4.32016 11.6802 1.3335 8.00016 1.3335ZM8.00016 13.3335C5.06016 13.3335 2.66683 10.9402 2.66683 8.00016C2.66683 5.06016 5.06016 2.66683 8.00016 2.66683C10.9402 2.66683 13.3335 5.06016 13.3335 8.00016C13.3335 10.9402 10.9402 13.3335 8.00016 13.3335ZM11.0602 5.0535L6.66683 9.44683L4.94016 7.72683L4.00016 8.66683L6.66683 11.3335L12.0002 6.00016L11.0602 5.0535Z'
                      fill={published ? '#0CF607' : 'red'}
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_4214_21524'>
                      <rect width='16' height='16' fill='white' />
                    </clipPath>
                  </defs>
                </svg>

                <p
                  style={{
                    fontSize: '14px',
                    color: published ? '#0CF607' : 'red',
                  }}
                >
                  {published ? 'Published' : 'Not Published'}
                </p>
              </div>
              <div className='school-card__body__flex__item'>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                    fill='#5A5955'
                  />
                  <path
                    d='M9.33317 11.3332H4.6665V9.99984H9.33317V11.3332ZM11.3332 8.6665H4.6665V7.33317H11.3332V8.6665ZM11.3332 5.99984H4.6665V4.6665H11.3332V5.99984Z'
                    fill='#5A5955'
                  />
                </svg>
                <p>{lesson_count} lesson(s)</p>
              </div>
            </div>

            <div className='school-card__body__flex'>
              <div className='school-card__body__flex__item'>
                <svg
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M5.99984 1.99984C6.73317 1.99984 7.33317 2.59984 7.33317 3.33317C7.33317 4.0665 6.73317 4.6665 5.99984 4.6665C5.2665 4.6665 4.6665 4.0665 4.6665 3.33317C4.6665 2.59984 5.2665 1.99984 5.99984 1.99984ZM5.99984 8.6665C7.79984 8.6665 9.8665 9.5265 9.99984 9.99984H1.99984C2.15317 9.51984 4.2065 8.6665 5.99984 8.6665ZM5.99984 0.666504C4.5265 0.666504 3.33317 1.85984 3.33317 3.33317C3.33317 4.8065 4.5265 5.99984 5.99984 5.99984C7.47317 5.99984 8.6665 4.8065 8.6665 3.33317C8.6665 1.85984 7.47317 0.666504 5.99984 0.666504ZM5.99984 7.33317C4.21984 7.33317 0.666504 8.2265 0.666504 9.99984V11.3332H11.3332V9.99984C11.3332 8.2265 7.77984 7.33317 5.99984 7.33317Z'
                    fill='#5A5955'
                  />
                </svg>

                <p
                  style={{
                    fontSize: '14px',
                  }}
                >
                  {type || 'Student Paced'}
                </p>
              </div>
              <div className='school-card__body__flex__item'>
                {/* <svg
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M10.6667 1.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.593333 0 0 0.6 0 1.33333V10.6667C0 11.4 0.593333 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM6 6C4.9 6 4 5.1 4 4C4 2.9 4.9 2 6 2C7.1 2 8 2.9 8 4C8 5.1 7.1 6 6 6ZM6 3.33333C5.63333 3.33333 5.33333 3.63333 5.33333 4C5.33333 4.36667 5.63333 4.66667 6 4.66667C6.36667 4.66667 6.66667 4.36667 6.66667 4C6.66667 3.63333 6.36667 3.33333 6 3.33333ZM10 10H2V8.98C2 7.31333 4.64667 6.59333 6 6.59333C7.35333 6.59333 10 7.31333 10 8.98V10ZM3.54 8.66667H8.46C8 8.29333 6.87333 7.92 6 7.92C5.12667 7.92 3.99333 8.29333 3.54 8.66667Z'
                    fill='#5A5955'
                  />
                </svg> */}

                {/* <p>6 Enrolled</p> */}
                <p></p>
              </div>
            </div>
          </>
        ) : (
          <div className='school-card__body__flex'>
            <div className='school-card__body__flex__item'>
              <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M13.3333 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H13.3333C14.0667 14 14.6667 13.4 14.6667 12.6667V3.33333C14.6667 2.6 14.0667 2 13.3333 2ZM13.3333 3.33333V5.33333H3.33333V3.33333H13.3333ZM10 12.6667H6.66667V6.66667H10V12.6667ZM3.33333 6.66667H5.33333V12.6667H3.33333V6.66667ZM11.3333 12.6667V6.66667H13.3333V12.6667H11.3333Z'
                  fill='#5A5955'
                />
              </svg>

              <p style={{ fontSize: '14px' }}>{'English Language'}</p>
            </div>

            <div className='school-card__body__flex__item'>
              <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                  fill='#5A5955'
                />
                <path
                  d='M9.33366 11.3332H4.66699V9.99984H9.33366V11.3332ZM11.3337 8.6665H4.66699V7.33317H11.3337V8.6665ZM11.3337 5.99984H4.66699V4.6665H11.3337V5.99984Z'
                  fill='#5A5955'
                />
              </svg>
              <p style={{ fontSize: '14px' }}>{duration || 0}</p>
            </div>
          </div>
        )}
        {tutor ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px',
              alignItems: 'center',
            }}
          >
            <Button
              text={tutor ? 'View Lesson' : 'Start Learning'}
              className='orange-border'
              width='100%'
              onClick={tutor ? () => viewLesson(id) : selectSchool}
            />
            <Popover
              content={
                <div className='popover-item'>
                  {/* <p onClick={() => navigate(`/update-lesson/${id}`)}>
                    Update Lesson
                  </p> */}
                  {!published && (
                    <p
                      onClick={() => publishCourse(course, el)}
                      className='popover-item__single'
                    >
                      Publish
                    </p>
                  )}
                  <p
                    className='popover-item__single'
                    onClick={() => navigate(`/tutor/courses/${id}?edit=true`)}
                  >
                    Edit lesson
                  </p>
                  <p
                    className='popover-item__single'
                    onClick={() => navigate(`/update-course/${id}`)}
                  >
                    Edit subject information
                  </p>
                  <p
                    className='popover-item__single'
                    onClick={() => navigate(`/update-course/${id}?tab=topic`)}
                  >
                    Edit topic title
                  </p>
                  <p
                    onClick={() => setVisible(true)}
                    className='popover-item__single'
                  >
                    Delete course
                  </p>
                </div>
              }
              trigger='click'
              open={open}
              onOpenChange={handleOpenChange}
            >
              <div className='card-popover'>
                <svg
                  width='4'
                  height='12'
                  viewBox='0 0 4 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M2.00033 3.33335C2.73366 3.33335 3.33366 2.73335 3.33366 2.00002C3.33366 1.26669 2.73366 0.666687 2.00033 0.666687C1.26699 0.666687 0.666992 1.26669 0.666992 2.00002C0.666992 2.73335 1.26699 3.33335 2.00033 3.33335ZM2.00033 4.66669C1.26699 4.66669 0.666992 5.26669 0.666992 6.00002C0.666992 6.73335 1.26699 7.33335 2.00033 7.33335C2.73366 7.33335 3.33366 6.73335 3.33366 6.00002C3.33366 5.26669 2.73366 4.66669 2.00033 4.66669ZM2.00033 8.66669C1.26699 8.66669 0.666992 9.26669 0.666992 10C0.666992 10.7334 1.26699 11.3334 2.00033 11.3334C2.73366 11.3334 3.33366 10.7334 3.33366 10C3.33366 9.26669 2.73366 8.66669 2.00033 8.66669Z'
                    fill='#5A5955'
                  />
                </svg>
              </div>
            </Popover>
          </div>
        ) : (
          <Button
            text={tutor ? 'View Lesson' : 'Start Learning'}
            className='orange-border'
            width='100%'
            onClick={tutor ? () => viewLesson(id) : selectSchool}
          />
        )}
      </div>
      <Modal
        width={606}
        visible={visible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Delete />
            </div>
            <h2>Delete Lesson?</h2>
            <p style={{ marginBottom: '32px' }}>
              Are you sure you want to delete <b>{el?.title}</b>
            </p>
            <Button
              text={'Yes'}
              className='w-full'
              onClick={() => deleteCourse(course?.id)}
            />
            <p style={{ marginTop: '32px' }} onClick={() => handleCancel()}>
              Cancel
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LearnSubjectCard;
